import { ICustomer } from '../../model/customer.model';

export const initialState: ICustomer = {
  civility: '',
  birthday: null,
  firstName: '',
  lastName: '',
  familyName: '',
  cityOfBirth: '',
  streetNumber: '',
  address: '',
  email: '',
  confirmEmail: '',
  additionalAddress: '',
  zipCode: null,
  city: '',
  phoneNumber: '',
  mobileNumber: '',
  iso2country: 'FR',
  bankAccountOwner: '',
  iban: null,
  BIC: null,
  iso2countryOfBirth: 'FR',
  checkboxSign: false,
  legalRepresentative: '',
  legalRepresentativeTitle: '',
  siret: '',
  socialReason: '',
  changeAddressManually: false,
  selectAddressAutocompletete: false
};

export type CustomerState = Readonly<typeof initialState>;
